<section class="section-white" *ngIf="eventDetailData?.header">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-32">{{ eventDetailData?.header }}</h2>
    <div class="flex-col gap-48">
      <div class="multi-row-grid">
        <div
          class="blog-container"
          *ngFor="let card of eventDetailData?.relatedEvents"
        >
          <ng-container
            *ngTemplateOutlet="figureTemplate; context: { item: card }"
          ></ng-container>
        </div>
      </div>

      <div class="single-row-scroll">
        <div class="item blog-container-mobile" *ngFor="let card of eventDetailData?.relatedEvents">
          <ng-container
            *ngTemplateOutlet="figureTemplate; context: { item: card }"
          ></ng-container>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #figureTemplate let-item="item">
  <ng-container *ngIf="item?.fields?.title">
    <div class="blog-image">
      <img
        class="responsive-radius-xl"
        src="{{ item?.fields?.blogImage?.fields?.file?.url }}"
        alt="{{ item?.fields?.blogImage?.fields?.title }}"
      />
    </div>
    <div class="latest-news-content">
      <h5 class="latest-news-heading">
        {{ item?.fields?.title }}
      </h5>
    </div>
    <a
      href="{{'about-us/media-and-events/events/detail/' + item?.fields?.webPageId | urlParams:queryParams}}"
      class="stretched-link"
    ></a>
  </ng-container>
</ng-template>
